/**
 * BCP-47 shapes after /:region: language-region (en-AU) or language-script-region (zh-Hant-TW).
 * Group 1: region prefix (/au). Group 2: locale tag (de-DE).
 */
const LOCALE_SEGMENT_PATTERN = '[a-z]{2}-(?:[A-Z][a-z]{3}-)?[A-Z]{2}'
const LOCALE_PATHNAME_MATCH =
  new RegExp(`^(\\/[a-zA-Z]{2})\\/(${LOCALE_SEGMENT_PATTERN})(?=\\/|$|\\?|#)`)

function pathnameFromRequestUrl(url: string): string {
  const withoutHash = url.split('#')[0] ?? ''
  return (withoutHash.split('?')[0] ?? '').trim()
}

function splitPathnameFromSuffix(url: string): [string, string] {
  const suffixIndex = url.search(/[?#]/)
  return suffixIndex === -1 ? [url, ''] : [url.slice(0, suffixIndex), url.slice(suffixIndex)]
}

export function getLocaleFromPathname(pathname: string): string | null {
  const m = pathname.match(LOCALE_PATHNAME_MATCH)
  return m ? m[2] : null
}

export function getLocaleFromRequestUrl(url: string): string | null {
  return getLocaleFromPathname(pathnameFromRequestUrl(url))
}

/**
 * Removes a locale-shaped URL segment from the canonical position immediately
 * after the region, so locale-prefixed URLs still match `/:regionCode/...` routes.
 */
export function removeLocaleFromPathname(pathname: string): string {
  const [pathOnly, suffix] = splitPathnameFromSuffix(pathname)
  return `${pathOnly.replace(LOCALE_PATHNAME_MATCH, '$1')}${suffix}`
}

export { isSupportedLocale } from './localeMatcher'
